import * as Constants from "./constants";

/**
 * Reducer de gestion du token dans le store
 * @private
 * @param {object} state Le state de l'application
 * @param {object} action L'action contenant le type et la valeur
 */
function manageToken(state = Constants.INITIAL_STATE, action) {
  let nextState;
  switch (action.type) {
    case Constants.SET_TOKEN:
      // Mise à jour du token
      nextState = {
        ...state,
        token: {
          ...state.token,
          token: action.value,
          date: new Date(Date.now())
        }
      };
      return nextState || state;

    default:
      return state;
  }
}

export { manageToken };
